exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".erro-404-body[data-v-f54bb17c]{width:100%;height:100vh;background-color:#8b0000;position:absolute;margin:0;padding:0}.erro-message[data-v-f54bb17c]{font-size:35px}.erro-icon[data-v-f54bb17c],.erro-message[data-v-f54bb17c]{color:#fff;text-align:center}.erro-icon[data-v-f54bb17c]{font-size:260px}", ""]);

// exports
